var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { combineRules } from 'fela';
import { createComponent as createFelaComponent, ThemeProvider, connect } from 'react-fela';
import mergeOptions from 'merge-options';

var createComponent = function createComponent(rule) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';
  var passThroughProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return createFelaComponent(rule, type, type.propTypes ? passThroughProps.concat(Object.keys(type.propTypes)) : passThroughProps);
};

var applyTheme = function applyTheme(ComponentToWrap) {
  for (var _len = arguments.length, themes = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    themes[_key - 2] = arguments[_key];
  }

  var primaryTheme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

  var ThemedComponent = function (_Component) {
    _inherits(ThemedComponent, _Component);

    function ThemedComponent() {
      _classCallCheck(this, ThemedComponent);

      return _possibleConstructorReturn(this, (ThemedComponent.__proto__ || Object.getPrototypeOf(ThemedComponent)).apply(this, arguments));
    }

    _createClass(ThemedComponent, [{
      key: 'getChildContext',
      value: function getChildContext() {
        var contextTheme = this.context.theme || {};
        var resultTheme = _extends({}, contextTheme, primaryTheme(contextTheme));
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = themes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var theme = _step.value;

            if (theme) {
              resultTheme = _extends({}, mergeOptions(resultTheme, theme(contextTheme)));
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return {
          theme: _extends({}, resultTheme)
        };
      }
    }, {
      key: 'render',
      value: function render() {
        return React.createElement(ComponentToWrap, this.props);
      }
    }]);

    return ThemedComponent;
  }(Component);

  ThemedComponent.childContextTypes = { theme: PropTypes.object };
  ThemedComponent.contextTypes = { theme: PropTypes.object };
  return ThemedComponent;
};

var createComponentStyles = function createComponentStyles(styleFunctions, component) {
  return connect(styleFunctions)(component);
};

export { createComponent, applyTheme, ThemeProvider, connect, combineRules, createComponentStyles };


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-style-container/es/index.js
// module id = 111
// module chunks = 0